import { CanAccess, EditBase, Form, required } from "ra-core";
import { Navigate } from "react-router";
import { Card, CardContent } from "@/components/ui/card";
import { SelectInput } from "@/components/admin/select-input";
import { TextInput } from "@/components/admin/text-input";

import { FormToolbar } from "../layout/FormToolbar";
import { AUTHORIZATION_TO_SELL_STATUS_CHOICES } from "./authorizationToSellStatus";

/**
 * ASSUMPTION: no delete action here — catalogue records (developers) are
 * never hard-deleted, enforced both in the UI (canAccess.ts) and at the
 * database level (TASK-001).
 *
 * The whole page is gated by `canAccess` so a non-direccion role can't reach
 * an editable form by typing the URL directly (react-admin's
 * <Resource edit=.../> route itself is not access-gated).
 *
 * ASSUMPTION (Almikia Epic E1b, TASK-031): the five legacy fiscal inputs
 * (rfc, fiscal_zip_code, tax_regime, cfdi_use, invoice_email) are removed
 * from this form — fiscal data now lives in `developer_fiscal_profiles`
 * (TASK-027/TASK-034). The legacy columns stay in the database, unused by
 * the UI (see the `Developer` type's deprecated fields), so no migration is
 * needed here.
 */
export const DeveloperEdit = () => (
  <CanAccess
    resource="developers"
    action="edit"
    accessDenied={<Navigate to="/developers" replace />}
  >
    <EditBase actions={false} redirect="list">
      <div className="mt-2 max-w-lg mx-auto">
        <Card>
          <CardContent>
            <Form className="space-y-4 pt-4">
              <TextInput
                source="legal_name"
                validate={required()}
                helperText={false}
              />
              <SelectInput
                source="authorization_to_sell_status"
                choices={AUTHORIZATION_TO_SELL_STATUS_CHOICES}
                validate={required()}
                helperText={false}
              />
              <FormToolbar />
            </Form>
          </CardContent>
        </Card>
      </div>
    </EditBase>
  </CanAccess>
);
